import { render, staticRenderFns } from "./ViewSscInfo.vue?vue&type=template&id=2fe9793a&"
import script from "./ViewSscInfo.vue?vue&type=script&lang=js&"
export * from "./ViewSscInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ViewSscInfo.vue"
export default component.exports